import React, { useState } from 'react';
import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { A8Data } from "@uniphore/data-ui";
import NoData from '../../../apps/NoData'
import { ReactComponent as WarningIcon } from '../../../../assets/svg/warningIcon.svg'

const Data: React.FC = () => {

    const params: any = useParams()
    const appId = params && params.appId

    const [isForbidden, setIsForbidden] = useState(false)

    const currentApp = useSelector((state: any) => {
        return state.apps.appVersion[appId]
    }, (oldData: any, newData: any) => JSON.stringify(oldData) === JSON.stringify(newData))

    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const appPermissions: any = useSelector((state: any) => {
        return state.apps.selectedApp.permissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const currentBranch: any = useSelector((state: any) => {
        const selectedAppId = state.apps.selectedApp && state.apps.selectedApp.id
        return (state.apps.appBranch && state.apps.appBranch[selectedAppId]) || {}
    }, (left: any, right: any) => left.branchId === right.branchId)

    const versionId = currentApp && currentApp.versionId
    const previousVersionId = currentApp && currentApp.previousVersionId
    const isCurrentVersion = currentApp && currentApp.currentVersion
    const canEditData = isCurrentVersion && (orgPermissions.includes('data.Edit') || appPermissions.includes('data.Edit'))
    const canCreateData = isCurrentVersion && (orgPermissions.includes('data.Create') || appPermissions.includes('data.Create'))
    const canDeleteData = isCurrentVersion && (orgPermissions.includes('data.Delete') || appPermissions.includes('data.Delete'))
    const canViewData = isCurrentVersion && (orgPermissions.includes('data.View') || appPermissions.includes('data.View'))
    const branchId = currentBranch.branchId

    const token: any = localStorage.getItem("studioToken")
    return (
        <React.Fragment>
            {
                !isForbidden ?
                    <A8Data
                        appId={appId}
                        versionId={versionId}
                        previousVersionId={previousVersionId}
                        from='studio'
                        token={token}
                        canEdit={canEditData}
                        canCreate={canCreateData}
                        canDelete={canDeleteData}
                        canView={canViewData}
                        setIsForbidden={setIsForbidden}
                        branchId={branchId}
                        appType="assisted"
                    />
                    :
                    <div className="viewWrapper">
                        <NoData
                            svg={WarningIcon}
                            header='Not Authorized'
                            content='Please request owner of this organization to provide access'
                            noButton={true}
                        />
                    </div>
            }
        </React.Fragment>
    )
}

export default Data;
